import * as React from 'react';
import { useIntl } from 'react-intl';
import { Alert } from '@manulife/mux';
import { FormattedRichMessage, ContentPage } from 'ciam-self-service-shared';
import Page from 'components/common/Page';
import AnalyticsDataLayer from '../../common/Analytics';

const CONFIRM_MAIL_ERROR_PAGE = 'confirm-mail-error';

function ErrorPage() {
  const intl = useIntl();

  return (
    <Page title={intl.formatMessage({ id: 'signupVerify.error.title' })}>
      <AnalyticsDataLayer pageName={CONFIRM_MAIL_ERROR_PAGE} error="ConfirmMailError" />
      <ContentPage>
        <Alert severity={Alert.SEVERITY.ALERT}>
          <FormattedRichMessage id="signupVerify.error.messageCard" />
        </Alert>
      </ContentPage>
    </Page>
  );
}

export default ErrorPage;
